<template>
    <div>
        <app-text
            label="Name"
            :data-source="'deha.user.misc.brands.' + listitemId + '.data.name'"
            :data-preset="'Listpresets.brands'"
            :data-default="{ type: 'raw', value: 'Ihre Marke' }"
            required
            :maxlength="255"
        ></app-text>

        <app-text
            label="Link zur Website"
            :data-source="'deha.user.misc.brands.' + listitemId + '.data.link'"
            :data-default="{ type: 'raw', value: 'https://www.tecworld.com' }"
            pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
            autoformat="url"
            :maxlength="255"
            required
            revalidate-source="link"
            revalidate-target="link"
        ></app-text>

        <app-filepicker
            label="Bild"
            :data-source="'deha.user.misc.brands.' + listitemId + '.data.icon'"
            accept=".jpg,.png,.gif"
        ></app-filepicker>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'generateMediaUrl', 'getActiveIconstyle'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R097'),
            help: this.$helpers.uiText('R098'),
            removeText: this.$helpers.uiText('R099')
        });
    },
    props: {
        moduleId: String,
        listitemId: String
    },
    components: {
        'app-text': Text,
        'app-filepicker': Filepicker
    }
};
</script>
